<template>
  <div class="" v-if="isPropertyLoading">
    <Loading />
  </div>

  <div v-else>
    <BethsLayout :layoutTitle="`Login - ${property?.name}`">
      <div class="flex flex-col justify-center min-h-600">
        <div
          class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
        >
          <div class="px-8 py-8 rounded-xl">
            <h1
              id="unsubscribe-title"
              name="unsubscribe-title"
              class="mt-2 font-normal text-2xl"
            >
              <div class="font-normal">Unsubscribe from Alert notifications</div>
              <div class="font-bold">{{ property?.name }}</div>
            </h1>

            <Loading v-if="isLoggingIn" />
            <div v-if="success" class="p-4 my-4 bg-green-100 border">
              <div class="flex">
                <div class="w-12 h-12">
                  <!-- <i-heroicons-outline-exclamation-circle
                    class="h-12 w-12 text-green-900"
                  /> -->
                </div>
                <span class="pt-3 pl-2 pr-12 text-2xl text-green-900">
                  Unsubscribe Successful.
                </span>
              </div>

              <p class="mb-2 ml-14 pr-12 text-lg text-green-900">
                You will no longer receive notifications.
              </p>
            </div>
            <ErrorDisplay
              label="Unsubscribe Error"
              id="unsubscribe-error"
              :message="errorLabel"
              :message-is-html="true"
              :isVisible="errorLabel?.length > 0"
            />

            <form action="" class="mt-8" v-if="property?.isPasswordLoginEnabled ?? true">
              <div class="my-5 text-sm">
                <label
                  for="email_address"
                  id="email_address_lael"
                  class="block text-black"
                >
                  Email Address
                </label>
                <input
                  id="email_address"
                  v-model="email"
                  type="text"
                  autofocus
                  class="w-full px-4 text-xl font-mono py-3 mt-2 bg-gray-200 border border-gray-400 rounded-sm focus:outline-double"
                  placeholder="caleb@company.com"
                />
              </div>
              <div class="flex flex-wrap justify-between flex-row-reverse mt-8">
                <button
                  id="unsubscribe_button"
                  class="w-40 flex py-3 px-3 text-center text-white duration-300 bg-btn hover:bg-blue-500 rounded"
                  @click.prevent="unsubscribeClick"
                >
                  <span class="flex-grow text-xl pr-5">Unsubscribe</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </BethsLayout>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onActivated, watch } from "vue";

import { useUserStore } from "../store/userStore";
import { useBldgStore } from "../store/bldgStore";
import { useAlertStore } from "../store/alertStore";
import { useRoute } from "vue-router";

const userStore = useUserStore();
const bldgStore = useBldgStore();
const alertStore = useAlertStore();
const route = useRoute();

var isPropertyLoading = computed(() => bldgStore.isLoading);
let isLoading = ref(false);
var property = computed(() => bldgStore.building);
let isLoggingIn = ref(false);

onMounted(loadData);
onActivated(() => loadData);
watch(property, loadData);

const email = ref(route.query?.user?.toString() ?? "");
//const email = ref(Array.isArray(route.query["user"]) ? "" : route.query?.user?.toString());

async function loadData() {
  console.log("Unsubscribe: Loading. " + email.value);
  isLoading.value = true;
  if (property?.value?.portalId && !email.value) {
    await userStore.getUser(property?.value?.siteCode!, property?.value?.portalId!);
    email.value = userStore.user?.contactEmail ?? "";
  }
  isLoading.value = false;
}

let errorLabel = ref<string | undefined>(undefined);
let success = ref(false);

async function unsubscribeClick() {
  console.log(`Attempting unsubscribe for: ${email.value}`);

  if (email.value === "") {
    errorLabel.value = "Enter your email address to unsubscribe";
    return;
  }

  isLoggingIn.value = true;
  errorLabel.value = "";
  success.value = false;

  let unsubscribeResult = await alertStore.unsubscribe(email.value!);

  if (!unsubscribeResult) {
    success.value = true;
    email.value = "";
    isLoggingIn.value = false;
  } else {
    console.log("unsubscribeResult:", unsubscribeResult);
    if (unsubscribeResult === '"User not found"') {
      errorLabel.value = "User not found";
    } else {
      errorLabel.value = "Couldn't Unsubscribe. Please try again later.";
    }
    isLoggingIn.value = false;
  }
}
</script>
